var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E89C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8766 11.7456C11.3432 11.6027 10.7948 11.9193 10.6519 12.4527L8.06368 22.112C7.92074 22.6455 8.23732 23.1938 8.77079 23.3367L27.1234 28.2543C27.6568 28.3972 28.2052 28.0807 28.3481 27.5472L30.9363 17.8879C31.0793 17.3545 30.7627 16.8061 30.2292 16.6632L11.8766 11.7456ZM23.3637 21.0352C22.7919 23.1691 20.5986 24.4354 18.4647 23.8637C16.3309 23.2919 15.0645 21.0986 15.6363 18.9647C16.2081 16.8308 18.4014 15.5645 20.5353 16.1363C22.6691 16.708 23.9355 18.9014 23.3637 21.0352Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14C9.44772 14 9 14.4477 9 15V25C9 25.5523 9.44772 26 10 26H29C29.5523 26 30 25.5523 30 25V15C30 14.4477 29.5523 14 29 14H10ZM23.5 20C23.5 22.2091 21.7091 24 19.5 24C17.2909 24 15.5 22.2091 15.5 20C15.5 17.7909 17.2909 16 19.5 16C21.7091 16 23.5 17.7909 23.5 20ZM19.5 22C20.6046 22 21.5 21.1046 21.5 20C21.5 18.8954 20.6046 18 19.5 18C18.3954 18 17.5 18.8954 17.5 20C17.5 21.1046 18.3954 22 19.5 22Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pay.svg";